export const matrixReviewDate = '2026-07-12';

export const dodDisclaimer = 'SkillBridge.guru is an independent training provider. References to DoD 8140, the DCWF and commercial certifications are provided for informational and exam-preparation purposes. The inclusion of a commercial certification in an official qualification matrix does not mean that SkillBridge.guru is approved, endorsed or affiliated with the U.S. Department of Defense or the certification owner. Completing a SkillBridge course or passing a certification exam does not by itself establish full DoD 8140 qualification. Qualification depends on the individual\'s assigned work role, proficiency level, current official matrix, employer or component requirements, resident qualification and other applicable conditions. Candidates must verify requirements with their supervisor, Cyber Workforce Program Manager, employer or contracting authority before enrolling.';

export const featuredCategories = [
  ['Foundational IT and Cybersecurity', ['ISC2 Certified in Cybersecurity Exam Preparation', 'CompTIA A+ Exam Preparation', 'CompTIA Network+ Exam Preparation', 'CompTIA Security+ Exam Preparation']],
  ['Cyber Defense and Security Operations', ['CompTIA CySA+ Exam Preparation', 'Cisco Cyber Operations Certification Preparation', 'GIAC GSEC Preparation', 'GIAC GCIA Preparation', 'GIAC GCIH Preparation']],
  ['Vulnerability Assessment and Penetration Testing', ['CompTIA PenTest+ Exam Preparation', 'EC-Council CEH Exam Preparation', 'EC-Council CEH Practical Preparation', 'EC-Council CND Exam Preparation', 'GIAC GPEN Preparation']],
  ['Incident Response and Digital Forensics', ['EC-Council CHFI Exam Preparation', 'EC-Council ECIH Exam Preparation', 'GIAC GCFA Preparation', 'GIAC GCFE Preparation', 'GIAC GREM Preparation']],
  ['Cloud Security and Security Architecture', ['CompTIA Cloud+ Exam Preparation', 'ISC2 CCSP Exam Preparation', 'CompTIA SecurityX Exam Preparation', 'ISC2 CSSLP Exam Preparation', 'Cisco CCNP Security Preparation', 'ISC2 CISSP-ISSAP Preparation', 'ISC2 CISSP-ISSEP Preparation']],
  ['Governance, Risk, Audit and Leadership', ['ISC2 CGRC Exam Preparation', 'ISACA CISA Exam Preparation', 'ISACA CISM Exam Preparation', 'ISC2 CISSP Exam Preparation', 'ISC2 SSCP Exam Preparation', 'GIAC GSLC Preparation']],
];

export const priorityCourses = [
  {
    slug: 'security-plus-training',
    certification: 'CompTIA Security+',
    title: 'CompTIA Security+ Exam Preparation',
    owner: 'CompTIA',
    status: 'Independent Exam Preparation',
    summary: 'Foundational cybersecurity preparation for analysts, administrators and technical staff who need broad security, risk, architecture and operations fluency.',
    level: 'Foundational to intermediate',
    mappedRoles: 'Use the official matrix to verify current DCWF applicability for the assigned role.',
    mappingLevel: 'Basic / Intermediate when officially mapped',
    availability: 'Live online, onsite and private group',
    duration: '5 days or custom team schedule',
    labs: 'Guided labs and practice scenarios',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'SY0-701',
    domains: ['security concepts', 'threats and vulnerabilities', 'architecture', 'operations', 'governance and risk'],
  },
  {
    slug: 'cissp-training',
    certification: 'ISC2 CISSP',
    title: 'ISC2 CISSP Exam Preparation',
    owner: 'ISC2',
    status: 'Independent Exam Preparation',
    summary: 'Senior security management and architecture preparation across governance, risk, engineering, operations, identity, assessment and software security.',
    level: 'Advanced',
    mappedRoles: 'Architecture, management and senior cybersecurity roles when listed in the current matrix.',
    mappingLevel: 'Advanced when officially mapped',
    availability: 'Live online and private group',
    duration: '5 days or executive schedule',
    labs: 'Scenario reviews and practice assessments',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'Current CISSP exam outline',
    domains: ['security and risk management', 'asset security', 'architecture and engineering', 'communications', 'identity', 'assessment', 'operations', 'software security'],
  },
  {
    slug: 'cysa-plus-training',
    certification: 'CompTIA CySA+',
    title: 'CompTIA CySA+ Exam Preparation',
    owner: 'CompTIA',
    status: 'Independent Exam Preparation',
    summary: 'Security operations and analytics preparation for monitoring, detection, vulnerability management, incident response and reporting roles.',
    level: 'Intermediate',
    mappedRoles: 'Cyber defense and security operations roles when listed in the current matrix.',
    mappingLevel: 'Intermediate when officially mapped',
    availability: 'Live online and private group',
    duration: '5 days',
    labs: 'SOC workflow labs',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'CS0-003',
    domains: ['security operations', 'vulnerability management', 'incident response', 'reporting and communication'],
  },
  {
    slug: 'securityx-training',
    certification: 'CompTIA SecurityX',
    title: 'CompTIA SecurityX Exam Preparation',
    owner: 'CompTIA',
    status: 'Independent Exam Preparation',
    summary: 'Advanced security architecture and engineering preparation for experienced practitioners working with enterprise environments.',
    level: 'Advanced',
    mappedRoles: 'Advanced technical and architecture roles when listed in the current matrix.',
    mappingLevel: 'Advanced when officially mapped',
    availability: 'Private group',
    duration: '5 days',
    labs: 'Architecture and risk scenarios',
    voucher: 'Optional',
    nextBatch: 'Private or corporate batch',
    examVersion: 'CAS-005 / current SecurityX outline',
    domains: ['architecture', 'engineering', 'governance', 'enterprise operations'],
  },
  {
    slug: 'ccsp-training',
    certification: 'ISC2 CCSP',
    title: 'ISC2 CCSP Exam Preparation',
    owner: 'ISC2',
    status: 'Independent Exam Preparation',
    summary: 'Cloud security preparation for practitioners responsible for cloud architecture, data protection, platform security and compliance.',
    level: 'Intermediate to advanced',
    mappedRoles: 'Cloud security and architecture roles when listed in the current matrix.',
    mappingLevel: 'Intermediate / Advanced when officially mapped',
    availability: 'Live online and private group',
    duration: '5 days',
    labs: 'Cloud risk and design exercises',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'Current CCSP exam outline',
    domains: ['cloud concepts', 'data security', 'platform security', 'application security', 'operations', 'legal and compliance'],
  },
  {
    slug: 'cism-training',
    certification: 'ISACA CISM',
    title: 'ISACA CISM Exam Preparation',
    owner: 'ISACA',
    status: 'Independent Exam Preparation',
    summary: 'Security management preparation for governance, risk, program development, operations and incident management leaders.',
    level: 'Advanced',
    mappedRoles: 'Leadership and management roles when listed in the current matrix.',
    mappingLevel: 'Advanced when officially mapped',
    availability: 'Live online and private group',
    duration: '4 days',
    labs: 'Governance case studies',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'Current CISM exam outline',
    domains: ['governance', 'risk management', 'program management', 'incident management'],
  },
  {
    slug: 'cgrc-training',
    certification: 'ISC2 CGRC',
    title: 'ISC2 CGRC Exam Preparation',
    owner: 'ISC2',
    status: 'Independent Exam Preparation',
    summary: 'Governance, risk and compliance preparation for authorization, risk management framework and control assessment responsibilities.',
    level: 'Intermediate',
    mappedRoles: 'Risk, compliance and authorization roles when listed in the current matrix.',
    mappingLevel: 'Intermediate when officially mapped',
    availability: 'Live online and private group',
    duration: '4 days',
    labs: 'RMF documentation scenarios',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'Current CGRC exam outline',
    domains: ['information security risk management', 'authorization', 'control selection', 'implementation', 'assessment', 'monitoring'],
  },
  {
    slug: 'pentest-plus-training',
    certification: 'CompTIA PenTest+',
    title: 'CompTIA PenTest+ Exam Preparation',
    owner: 'CompTIA',
    status: 'Independent Exam Preparation',
    summary: 'Assessment preparation for vulnerability identification, exploitation planning, tool use, reporting and remediation communication.',
    level: 'Intermediate',
    mappedRoles: 'Assessment and penetration testing roles when listed in the current matrix.',
    mappingLevel: 'Intermediate when officially mapped',
    availability: 'Private group',
    duration: '5 days',
    labs: 'Assessment lab scenarios',
    voucher: 'Optional',
    nextBatch: 'Private or corporate batch',
    examVersion: 'PT0-002 / current PenTest+ outline',
    domains: ['planning', 'information gathering', 'attacks and exploits', 'reporting', 'tools'],
  },
  {
    slug: 'sscp-training',
    certification: 'ISC2 SSCP',
    title: 'ISC2 SSCP Exam Preparation',
    owner: 'ISC2',
    status: 'Independent Exam Preparation',
    summary: 'Operational security preparation for administrators and practitioners responsible for access controls, monitoring and incident handling.',
    level: 'Intermediate',
    mappedRoles: 'Operations and administration roles when listed in the current matrix.',
    mappingLevel: 'Basic / Intermediate when officially mapped',
    availability: 'Private group',
    duration: '5 days',
    labs: 'Operational security scenarios',
    voucher: 'Optional',
    nextBatch: 'Private or corporate batch',
    examVersion: 'Current SSCP exam outline',
    domains: ['access controls', 'security operations', 'risk', 'incident response', 'network security', 'systems security'],
  },
  {
    slug: 'cisa-training',
    certification: 'ISACA CISA',
    title: 'ISACA CISA Exam Preparation',
    owner: 'ISACA',
    status: 'Independent Exam Preparation',
    summary: 'Audit preparation for professionals assessing governance, systems acquisition, operations, resilience and information asset protection.',
    level: 'Intermediate to advanced',
    mappedRoles: 'Audit and assessment roles when listed in the current matrix.',
    mappingLevel: 'Intermediate / Advanced when officially mapped',
    availability: 'Live online and private group',
    duration: '4 days',
    labs: 'Audit case studies',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'Current CISA exam outline',
    domains: ['audit process', 'governance', 'systems lifecycle', 'operations and resilience', 'asset protection'],
  },
  {
    slug: 'network-plus-training',
    certification: 'CompTIA Network+',
    title: 'CompTIA Network+ Exam Preparation',
    owner: 'CompTIA',
    status: 'Independent Exam Preparation',
    summary: 'Networking foundation preparation for infrastructure, operations, troubleshooting and support roles.',
    level: 'Foundational',
    mappedRoles: 'IT and support roles when listed in the current matrix.',
    mappingLevel: 'Basic when officially mapped',
    availability: 'Live online and private group',
    duration: '5 days',
    labs: 'Network troubleshooting labs',
    voucher: 'Optional',
    nextBatch: 'Request schedule',
    examVersion: 'N10-009',
    domains: ['networking concepts', 'implementation', 'operations', 'security', 'troubleshooting'],
  },
  {
    slug: 'certified-in-cybersecurity-training',
    certification: 'ISC2 Certified in Cybersecurity',
    title: 'ISC2 Certified in Cybersecurity Exam Preparation',
    owner: 'ISC2',
    status: 'Independent Exam Preparation',
    summary: 'Entry-level cybersecurity preparation for learners building basic security principles, continuity, access and network concepts.',
    level: 'Foundational',
    mappedRoles: 'Entry and basic roles only when listed in the current matrix.',
    mappingLevel: 'Basic when officially mapped',
    availability: 'Self-paced or private group when scheduled',
    duration: '2 days',
    labs: 'Knowledge checks and guided exercises',
    voucher: 'Optional',
    nextBatch: 'Private or corporate batch',
    examVersion: 'Current CC exam outline',
    domains: ['security principles', 'business continuity', 'access controls', 'network security', 'security operations'],
  },
];

export const courseBySlug = Object.fromEntries(priorityCourses.map((course) => [course.slug, course]));
